import { SensorType } from "@/api/SensorsService"
import { Sensor } from "@/types/facility"

export function getSensor(
   sensors: Sensor[],
   type: SensorType = SensorType.STATIC
) {
   return sensors?.find((s) => s.type === type)
}
